module.exports = __webpack_public_path__ + "img/consultoria_4-3_682.84ead5c9.webp";